import Api from "app/services/common/Api";
import {
  WorkElecBzkndSearchModel,
  WorkElecSearchModel, WorkPlanUseBzkndData, WorkPlanUseBzkndYearData,
  WorkPwrUseBySsnTmz,
  WorkPwrUseBySsnTmzHour,
  WorkPwrUseBzkndData, WorkRePeakData
} from "app/model/work/workElectricModel";

export class WorkElectricService extends Api {
  private static service: WorkElectricService;

  public static getInstance(): WorkElectricService {
    if (!WorkElectricService.service) {
      WorkElectricService.service = new WorkElectricService();
    }
    return WorkElectricService.service;
  }

  public async getPwrRateData(param: WorkElecSearchModel) {
    const url = process.env.REACT_APP_URL_CO + '/work/electric/time/bzknd/pwr/use/tmz';
    return await super.get<WorkPwrUseBySsnTmz[]>(url, param, { timeout: 120000 });
  }

  public async getPwrAccumData(param: any) {
    const url = process.env.REACT_APP_URL_CO + "/work/electric/time/bzknd/pwr/use/tmz/hour";
    return await super.get<WorkPwrUseBySsnTmzHour[]>(url, param, { timeout: 120000 });
  }

  public async getPwrUseBzknd(param: WorkElecBzkndSearchModel) {
    const url = process.env.REACT_APP_URL_CO + '/work/electric/bzknd/all/pwr/use/bzknd';
    return await super.get<WorkPwrUseBzkndData[]>(url, param);
  }

  public async getBzkndPlanRate() {
    const url = process.env.REACT_APP_URL_CO + "/work/electric/plan/all/plan/use/agg/bzknd";
    return await super.get<WorkPlanUseBzkndData[]>(url);
  }

  public async getBzkndPlanMonthly(param: any) {
    const url = process.env.REACT_APP_URL_CO + "/work/electric/plan/bzknd/pwr/cost/agg/plan";
    return await super.get<WorkPlanUseBzkndYearData[]>(url, param);
  }

  public async getRePeakData(param: WorkElecSearchModel) {
    const url = process.env.REACT_APP_URL_CO + "/work/electric/stat/bzknd/energy/peak/agg/trend";
    return await super.get<WorkRePeakData[]>(url, param, { timeout: 120000 });
  }
}
